module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.hot), function(row, index) {
    return _c('div', {
      staticClass: "col-xl-3 col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg mb-0"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/hot/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('p', {
      staticClass: "txt mb-0",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("熱門話題")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9406086e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Hot.vue
// module id = 169
// module chunks = 1